import { AuthEndpoint } from './endpoints'
import {
  CheckRegister,
  RegisterMobile,
  SendMobileOtp,
  SendOtp,
  VerifyMobileOtp,
  VerifyOtp,
} from './types'
import { client } from '@/api/client'
import { handleError } from '@/utils/errorHandler'

export const sendOTPService = async (
  payload: SendOtp['Payload'],
): Promise<SendOtp['Response']> => {
  try {
    const res = await client.post(AuthEndpoint.sendOtp, payload, {
      timeout: 20000,
    })
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export const checkRegisterService = async (
  payload: CheckRegister['Payload'],
) => {
  try {
    const res = await client.post(AuthEndpoint.checkRegister, payload)
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export const verifyOtpService = async (payload: VerifyOtp['Payload']) => {
  try {
    const res = await client.post(AuthEndpoint.verifyOtp, payload, {
      timeout: 20000,
    })
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export const getLoginDisplay = async () => {
  try {
    const res = await client.get(AuthEndpoint.loginDisplay)
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export const sendMobileOTPService = async (
  payload: SendMobileOtp['Payload'],
): Promise<SendMobileOtp['Response']> => {
  try {
    const res = await client.post(AuthEndpoint.sendMobileOtp, payload)
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export const verifyMobileOtpService = async (
  payload: VerifyMobileOtp['Payload'],
) => {
  try {
    const res = await client.post(AuthEndpoint.verifyMobileOtp, payload)
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}

export const registerMobileService = async (
  payload: RegisterMobile['Payload'],
): Promise<RegisterMobile['Response']> => {
  try {
    const res = await client.post(AuthEndpoint.registerMobile, payload)
    return res.data.data
  } catch (error) {
    handleError(error)
    throw error
  }
}
